import React from 'react'
import cx from 'classnames'

export default (props = {}) => {
  const cls = cx('b-spinner', {
    'b-spinner--small': props.small
  })

  return (
    <div className={cls}>
      <div className="b-spinner__bounce1" />
      <div className="b-spinner__bounce2" />
      <div className="b-spinner__bounce3" />
    </div>
  )
}
